/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityAlternativeName
 */
export interface FacilityAlternativeName {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    organization_id?: string;
}

/**
 * Check if a given object implements the FacilityAlternativeName interface.
 */
export function instanceOfFacilityAlternativeName(value: object): value is FacilityAlternativeName {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FacilityAlternativeNameFromJSON(json: any): FacilityAlternativeName {
    return FacilityAlternativeNameFromJSONTyped(json, false);
}

export function FacilityAlternativeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityAlternativeName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
    };
}

export function FacilityAlternativeNameToJSON(json: any): FacilityAlternativeName {
    return FacilityAlternativeNameToJSONTyped(json, false);
}

export function FacilityAlternativeNameToJSONTyped(value?: FacilityAlternativeName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'facility_id': value['facility_id'],
        'organization_id': value['organization_id'],
    };
}

